/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { connect } from 'react-redux';
import { Skeleton } from 'antd-v5';
import { setLaunchFlagsForNav } from '../../../reducers/auth';
import applyPlanGating from '../../../utils/applyPlanGating';

import './styles.scss';
import Header from './Header';
import Footer from './Footer';

const LayoutV2 = ({
  title,
  breadcrumb,
  classProps,
  styleProps,
  headerStyles,
  maxWidth,
  contentStyles,
  actions,
  containerStyles,
  description,
  loading = false,
  merchantFlags,
  ...props
}) => {
  const isMounted = useRef(null);
  const flags = useFlags();

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    setLaunchFlagsForNav(applyPlanGating(flags, merchantFlags));
  }, [flags?.projectEdison]);

  const renderSkeleton = () => (
    <div className="p-left-40 p-btm-16 w-100-P p-right-15" style={{ maxWidth: maxWidth ?? '1200px' }}>
      <Skeleton.Button active block style={{ height: 32, marginBottom: 24 }} />
      <Skeleton active paragraph={{ rows: 8 }} />
      <Skeleton.Button active block style={{ height: 120, marginTop: 24 }} />
      <Skeleton.Button active block style={{ height: 120, marginTop: 24 }} />
    </div>
  );

  return (
    <div
      id="scrollWatchId"
      className={
        classProps
          ? `layout-main-v2 rem-pad-width ${classProps} scrollbar-y`
          : `layout-main-v2 rem-pad-width scrollbar-y`
      }
      style={styleProps}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }} className="scrollbar-y w-100-P h-100-P p-top-15">
        <Header
          breadcrumb={breadcrumb}
          title={title}
          maxWidth={maxWidth}
          headerStyles={headerStyles}
          actions={actions}
          description={description}
        />
        <div
          className="flex-col-left p-top-16 p-btm-16"
          style={{ backgroundColor: '#F5F5F5', justifyContent: 'space-between', flex: 1, ...containerStyles }}
        >
          {loading ? (
            renderSkeleton()
          ) : (
            <div
              className="p-left-40 p-btm-16 w-100-P p-right-15"
              style={{ maxWidth: maxWidth ?? '1200px', ...contentStyles }}
            >
              {props.children}
            </div>
          )}
          <Footer footerClass={props?.footerClass} />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  ...state.navigation,
  ...state.auth,
});
const mapDispatchToProps = dispatch => ({
  toggleMobileMenu(val) {
    dispatch({
      type: 'SHOW_MOBILE_NAV',
      payload: val,
    });
  },
  toggleMultiMobileMenu(val) {
    dispatch({
      type: 'SHOW_MOBILE_MULTI_NAV',
      payload: val,
    });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(LayoutV2);
